/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IWebgroupSearchContainerViewProps } from './webgroup-search-container';
import { Module } from '@msdyn365-commerce-modules/utilities';

export default (props: { isLoaded: boolean } & IWebgroupSearchContainerViewProps) => {
    if (props.isLoaded) {
        return (
            <div className='webgroup-container'>
                <LoadingSkeleton />
            </div>
        );
    }

    const { webgroupControls, webgroupSearchResults, searchControlsProps, searchContainerProps } = props;
    return (
        <div className='webgroup-container'>
            <div className='webgroup-search-container row'>
                <div className='col-sm-12 col-md-12 col-lg-4'>
                    {searchControlsProps && (
                        <Module {...searchControlsProps} key={0}>
                            {webgroupControls}
                        </Module>
                    )}
                </div>
                <div className='col-sm-12 cold-md-12 col-lg-8'>
                    {searchContainerProps && (
                        <Module {...searchContainerProps} key={0}>
                            {webgroupSearchResults}
                        </Module>
                    )}
                </div>
            </div>
        </div>
    );
};

function LoadingSkeleton() {
    return (
        <div className='skeleton-container'>
            <div className='skeleton-container__layout'>
                {/* Filters Column */}
                <div className='skeleton-container__filters'>
                    <div className='skeleton-container__filters-group'>
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className='skeleton skeleton--filter' />
                        ))}
                    </div>
                </div>

                {/* Content Column */}
                <div className='skeleton-container__content'>
                    {/* Breadcrumb */}
                    <div className='skeleton-container__breadcrumb'>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} className='skeleton skeleton--text' style={{ width: '80px' }} />
                        ))}
                    </div>

                    {/* Title */}
                    <div className='skeleton skeleton--title' />

                    {/* Product Card */}
                    <div className='skeleton-container__product-card'>
                        <div
                            style={{ display: 'flex', gap: '1.5rem', padding: '1.5rem', border: '1px solid #e0e0e0', borderRadius: '8px' }}
                        >
                            <div className='skeleton skeleton--image' />
                            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                                <div className='skeleton skeleton--text' style={{ width: '75%' }} />
                                <div className='skeleton skeleton--text' />
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className='skeleton-container__table'>
                        {/* Rows */}
                        {Array.from({ length: 4 }).map((_, i) => (
                            <div key={i} className='skeleton-container__table-row'>
                                <div className='skeleton skeleton--cell' />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
